import { Star, Quote, ThumbsUp } from "lucide-react";
import Reveal from "../components/Reveal";
import { TESTIMONIALS, FEATURED_IN } from "../data/content";

const Testimonials = () => (
  <div>
    <section className="relative overflow-hidden border-b border-slate-100">
      <div className="absolute -top-40 right-0 w-[600px] h-[600px] soft-orb" />
      <div className="max-w-7xl mx-auto px-4 md:px-8 pt-14 md:pt-20 pb-12 grid lg:grid-cols-2 gap-12 items-center relative">
        <Reveal>
          <span className="text-xs font-bold tracking-[0.22em] uppercase text-royal mb-5 block">Real Feedback. Real Impact.</span>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter text-navy-900 leading-[1.0]">
            Real results. Real routines.
          </h1>
          <p className="mt-6 text-lg text-slate-500 leading-relaxed max-w-md">
            Trusted by thousands who choose NARA to support energy, focus and daily wellness.
          </p>
          <div className="mt-8 flex items-center gap-4">
            <span className="font-heading text-5xl font-bold text-navy-900">4.8</span>
            <div>
              <div className="flex">{[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" />)}</div>
              <p className="text-sm text-slate-500 mt-1">Based on 2,500+ verified customer reviews</p>
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <img src="/images/lifestyle_woman_drink.png" alt="Customer enjoying NARA" className="rounded-3xl w-full object-cover shadow-xl" />
        </Reveal>
      </div>
    </section>

    <section className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24">
      <div className="grid md:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.1}>
            <div className="bg-white rounded-3xl p-8 border border-slate-100 shadow-[0_8px_30px_rgb(15,23,42,0.04)] h-full flex flex-col">
              <Quote className="w-9 h-9 text-sky-200" />
              <div className="flex mt-4">{[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-amber-400 text-amber-400" />)}</div>
              <p className="text-navy-900 mt-4 leading-relaxed flex-1">"{t.quote}"</p>
              <div className="mt-6 pt-6 border-t border-slate-100 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 rounded-full bg-gradient-to-br from-royal to-navy-900 text-white flex items-center justify-center font-heading font-semibold text-sm">
                    {t.name[0]}
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-navy-900">{t.name}</p>
                    <p className="text-xs text-slate-400">{t.location}</p>
                  </div>
                </div>
                <span className="flex items-center gap-1 text-xs text-slate-400"><ThumbsUp className="w-3.5 h-3.5" /> {t.helpful}</span>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>

    <section className="bg-[#FAFBFD] border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14">
        <p className="text-center text-xs font-bold tracking-[0.2em] uppercase text-slate-400 mb-8">
          Trusted by wellness communities and featured in
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-6">
          {FEATURED_IN.map((f) => (
            <span key={f} className="font-heading text-lg md:text-xl font-semibold text-slate-400">{f}</span>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default Testimonials;
